const theme = {
  colors: {
    primary: "#d03125",
    black: "#000000",
    background: "#EEEEEE",
    lightGrey: "#F5F5F5",
    grey: "#D9D9D9",
    blue: "#2793e8",
    white: "#FFFFFF",
  },
  fonts: {
    sans: "sans-serif",
  },
  paddings: {
    container: "15px",
    pageTop: "30px",
  },
  margins: {
    pageTop: "30px",
  },
};

export default theme;
